import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service worker disabled for development/debugging
// serviceWorkerRegistration.register({
//   onSuccess: () => console.log('[PWA] App is ready for offline use'),
//   onUpdate: (registration) => {
//     console.log('[PWA] New content is available; please refresh.');
//   }
// });
serviceWorkerRegistration.unregister();
